import React, { Component } from 'react'
import { Col, Form, Input, Row, Select } from 'antd'
import InputNumber from 'rc-input-number'
import _ from 'lodash'

import 'antd/lib/input-number/style/css'
import './TemplateBackgroundInformationForm.scss'

const FormItem = Form.Item
const { Option } = Select

export default class TemplateBackgroundInformationForm extends Component {
    render() {
        const { backgroundInformation, onInputChange } = this.props
        const {
            name,
            category,
            type,
            size,
            estate_name,
            site_location,
            site_address,
            flat,
            floor,
            client_name,
            company_name,
            client_email,
            client_number,
        } = backgroundInformation

        return (
            <Form className="TemplateBackgroundInformationForm" layout="inline">
            	<Row>
	            	<Col span={12}>
	            		<Row>
			        		<FormItem label="Category">
		                        <Select 
		                        	showSearch
		                        	placeholder="Category" 
		                        	dropdownMatchSelectWidth={false} 
		                        	value={category}
		                        	onChange={onInputChange.bind(this, 'category')}
		                        	filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
		                        >
		                            <Option value="RE">RE</Option>
		                            <Option value="OF">OF</Option>
		                            <Option value="MI">MI</Option>
		                        </Select>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Type">
		                        <Select 
		                        	showSearch
		                        	placeholder="Type" 
		                        	dropdownMatchSelectWidth={false} 
		                        	value={type} 
		                        	onChange={onInputChange.bind(this, 'type')}
		                        	filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
		                        >
		                            <Option value="Apartment">Apartment</Option>
		                            <Option value="House">House</Option>
		                            <Option value="Subdivided Flat">Subdivided Flat</Option>
		                            <Option value="Shop">Shop</Option>
		                            <Option value="NGO">NGO</Option>
		                            <Option value="Restaurant">Restaurant</Option>
		                            <Option value="Elderly House">Elderly House</Option>
	                                <Option value="School">School</Option>
	                                <Option value="Office">Office</Option>
		                        </Select>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Size">
					        	<InputNumber
	                                prefixCls="ant-input-number"
	                                formatter={value => `${value} ft²`} 
	                                parser={string => string.replace(/[^\d]/g, '')} 
					        		value={size}
					        		min={0}
					        		onChange={onInputChange.bind(this, 'size')}
					        	/>
					        </FormItem>
				        </Row>
			    		<Row>
			        		<FormItem label="Flat">
	            				<Input 
	            					style={{width: 42}}
	            					value={flat}
					        		onChange={onInputChange.bind(this, 'flat')}
	            					addonBefore="Flat"
	            				/>
					        </FormItem>
					    </Row>
					    <Row>
			        		<FormItem label="Floor">
	            				<Input 
	            					style={{width: 43}}
	            					value={floor}
					        		onChange={onInputChange.bind(this, 'floor')}
	            					addonAfter="/F"
	            				/>
					        </FormItem>
			    		</Row>
			    		<Row>
			        		<FormItem label="Estate Name">
	            				<Input
	            					value={estate_name}
					        		onChange={onInputChange.bind(this, 'estate_name')}
	            				/>
					        </FormItem>
		        		</Row>
				        <Row>
			        		<FormItem label="Location">
	            				<Input
	            					value={site_location}
					        		onChange={onInputChange.bind(this, 'site_location')}
	            				/>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Site Address">
	            				<Input
	            					style={{width: 250}}
	            					value={site_address}
					        		onChange={onInputChange.bind(this, 'site_address')}
	            				/>
					        </FormItem>
				        </Row>
			        </Col>
			        <Col span={12}>
			    		<Row>
			        		<FormItem label="Template Name">
	            				<Input 
	            					value={name}
					        		onChange={onInputChange.bind(this, 'name')}
	            				/>
					        </FormItem>
					    </Row>
	            		<Row>
			        		<FormItem label="Company Name">
					        	<Input 
					        		value={company_name}
					        		onChange={onInputChange.bind(this, 'company_name')}
					        	/>
					        </FormItem>
				        </Row>
	            		<Row>
			        		<FormItem label="Client Name">
					        	<Input
					        		value={client_name}
					        		onChange={onInputChange.bind(this, 'client_name')}
					        	/>
					        </FormItem>
	            		</Row>
				        <Row>
			        		<FormItem label="Client Number">
	            				<Input
	            					value={client_number}
					        		onChange={onInputChange.bind(this, 'client_number')}
	            					addonBefore="+852"
	            				/>
					        </FormItem>
				        </Row>
				        <Row>
			        		<FormItem label="Client Email">
						        <Input 
						        	value={client_email}
					        		onChange={onInputChange.bind(this, 'client_email')}
						        />
					        </FormItem>
				        </Row>
			        </Col>
		        </Row>
        	</Form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Commons/TemplateBackgroundInformationForm/TemplateBackgroundInformationForm.js